export const GET_LOCATIONS = 'CCM.GET_LOCATIONS'
export const LOCATION_SHOW_LOCATIONS = 'CCM.LOCATION_SHOW_LOCATIONS'
export const SEARCH_STORES = 'CCM.SEARCH_STORES'
